import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-8.5',
    userFields: 'mb-3 flex gap-6 max-sm:flex-col',
    messageField: 'mb-12 sm:mb-16',
    button: 'w-full md:max-w-[320px]',
    note: 'text-text-inactive mt-2 text-[12px] leading-[140%] font-[300] md:mt-3',
    title: 'heading-2xl md:heading-3xl mb-3 font-medium md:font-medium',
    description: 'text-s leading-[120%] font-[300]'
  }
});
